import { TypeContract } from '../../models/request-and-responses/rest-api/enums/typeContract.enum';
import { ISocketMessageWrapper } from './socket-message-wrapper.interface';

export interface IWrappedContractStateChangeMessage
    extends ISocketMessageWrapper<IContractStateChangeMessage> {}

export interface IContractStateChangeMessage {
    contractType: TypeContract;
    recipients: number[];
    contractId: number;
    oldState: string;
    newState: string;
    messaggio: string;
}
export class ContractStateChangeMessage implements IContractStateChangeMessage {
    contractId: number;
    contractType: TypeContract;
    messaggio: string;
    newState: string;
    oldState: string;
    recipients: number[];

    constructor(
        contractId: number,
        contractType: TypeContract,
        messaggio: string,
        newState: string,
        oldState: string,
        recipients: number[]
    ) {
        this.contractId = contractId;
        this.contractType = contractType;
        this.messaggio = messaggio;
        this.newState = newState;
        this.oldState = oldState;
        this.recipients = recipients;
    }

    static fromContractStateChangeMessage(message: IContractStateChangeMessage) {
        return new ContractStateChangeMessage(
            message.contractId,
            message.contractType,
            message.messaggio,
            message.newState,
            message.oldState,
            message.recipients
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/socket-messages/contract-state-change-message.ts